var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 19176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 150620",
    width: 88,
    height: 88,
    rx: 44,
    fill: "#66BD50",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 150619",
    x: 12,
    y: 12,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#66BD50",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 150618",
    x: 26,
    y: 26,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44 24C32.96 24 24 32.96 24 44C24 55.04 32.96 64 44 64C55.04 64 64 55.04 64 44C64 32.96 55.04 24 44 24ZM38.58 52.58L31.4 45.4C30.62 44.62 30.62 43.36 31.4 42.58C32.18 41.8 33.44 41.8 34.22 42.58L40 48.34L53.76 34.58C54.54 33.8 55.8 33.8 56.58 34.58C57.36 35.36 57.36 36.62 56.58 37.4L41.4 52.58C40.64 53.36 39.36 53.36 38.58 52.58Z",
    fill: "#66BD50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.b7be164ba5d7b7c9df9387577b5c6af1.svg";
export { ForwardRef as ReactComponent };